import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/main.scss'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import 'aos/dist/aos.css'
import {sync} from 'vuex-router-sync'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import {createVuetify} from 'vuetify'
import titulo from './components/titulo'
import Parallax from './components/Parallax'
import ModalCadastro from './components/ModalCadastro'

import VueGoogleMaps from '@fawmi/vue-google-maps'
import PForm from "./components/PForm";
// import 'vue-draggable-resizable-vue3/src/style.less'
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import VueTheMask  from 'vue-the-mask'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import TableIterator from "./components/TableIterator";
import MenuImagem from "./components/MenuImagem";
import {VueEditor} from "vue3-editor";
import VCropper from "./components/VCropper/VCropper";
// import {VueDraggableResizable} from "vue-draggable-resizable-vue3";
import VueYtframe from "vue3-ytframe";
import VConfirm from "./components/VConfirm";

const vuetify = createVuetify({
  components,
  directives,
})


const app = createApp(App)
sync(store, router)
app.use(router)
app.use(vuetify)
app.use(store)
app.use(VueYtframe)
app.use(VueTheMask)

app.component('v-confirm', VConfirm)
// app.use(Vue3DraggableResizable);
app.component('vue3-draggable-resizable', Vue3DraggableResizable)

app.component('pro-titulo', titulo)
app.component('parallax', Parallax)
app.component('pro-modal', ModalCadastro)
app.component('p-form', PForm)
app.component('table-iterator', TableIterator)
app.component('menu-imagem', MenuImagem)
app.component('vue-editor', VueEditor)
app.component('v-cropper', VCropper)
// A key precisará ser alterada depois
app.use(VueGoogleMaps, {
  load: {
    v: '3.51',
    key: 'AIzaSyAb0wzUYfv-8mxhDsIS8nv7ddodU-Df5Eo',
    libraries: 'visualization'

  }
})

app.mount('#app')
